import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useTeamMeetingTeamsQuery() {
	const userSession = useUserSession();

	return useQuery({
		queryKey: ['teamMeetingConfig', 'teams'],
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'TeamMeetingConfig/teams',
				}),
				'GET'
			);
		},
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}
